import React, { useState } from 'react';
import { Card, Row, Col, Typography, Button } from 'antd';
import {
  CalendarOutlined,
  ShipOutlined,
  ClockCircleOutlined,
  CarOutlined,
  CloudOutlined,
} from '@ant-design/icons';

const { Title } = Typography;

const DSRReportOptions = ({ onSelectReport }) => {
  const reportTypes = [
    {
      title: 'Calendar Day Report',
      icon: <CalendarOutlined style={{ fontSize: '24px' }} />,
      key: 'calendar',
      description: 'Daily activities and progress report',
    },
    // {
    //     title: 'Shipping Report',
    //     icon: <ShipOutlined style={{ fontSize: '24px' }} />,
    //     key: 'shipping',
    //     description: 'Shipping and logistics updates'
    // },
    {
      title: 'Night Shift Report',
      icon: <ClockCircleOutlined style={{ fontSize: '24px' }} />,
      key: 'night',
      description: 'Night shift activities and progress',
    },
    {
      title: 'Chassis Report',
      icon: <CarOutlined style={{ fontSize: '24px' }} />,
      key: 'chassis',
      description: 'Chassis and equipment status',
    },
    {
      title: 'Weather Report',
      icon: <CloudOutlined style={{ fontSize: '24px' }} />,
      key: 'weather',
      description: 'Weather conditions and impact',
    },
  ];

  return (
    <div className="dsr-report-options">
      <Title level={3} style={{ marginBottom: '24px' }}>
        Select Report Type
      </Title>
      <Row gutter={[16, 16]}>
        {reportTypes.map((report) => (
          <Col xs={24} sm={12} md={8} lg={6} key={report.key}>
            <Card
              hoverable
              onClick={() => onSelectReport(report.key)}
              className="report-option-card"
            >
              <div className="text-center">
                {report.icon}
                <Title level={4} style={{ marginTop: '16px' }}>
                  {report.title}
                </Title>
                <p className="report-description">{report.description}</p>
                <Button type="primary" onClick={() => onSelectReport(report.key)}>
                  Create Report
                </Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DSRReportOptions;
